




import { defineComponent } from '@vue/composition-api';

// import useAuth from '@/useAuth';

const Index = defineComponent({
  // setup() {},
});

export default Index;
